import React from 'react';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
import { Link } from 'gatsby';
const AllProductsCard = ({
  backgroundColor,
  id,
  body,
  productList,
  index,
  image,
  buttonText,
  buttonUrl,
  productIcon,
  speed,
}) => {
  const list = productList?.map(({ icon, description }) => {
    return (
      <div className="product-list-inner">
        <div className="product-list-icon">
          <LitImage image={icon} />
        </div>
        <div className="product-list-text">
          <LitStructuredText data={description} />
        </div>
      </div>
    );
  });
  {
    /* PurgeCSS include: Yellow, White, Black */
  }
  const productCardContent = (
    <div
      className={`product-card ${backgroundColor}Mode`}
      key={index}
      id={`${id}`}
    >
      <div className="product-card-inner">
        <div className="product-card-image-container">
          <div className="product-card-image-text">
            <LitImage image={productIcon} alt="name of product" />
            <p className="product-card-speed">
              <span>
                <LitStructuredText data={speed} basic />
              </span>
              upload & download speeds
            </p>
            <p className="product-card-unlimited">+ unlimited data</p>
          </div>
          <div className="product-card-image">
            <LitImage image={image} alt="product" />
          </div>
        </div>
        <div className={`product-card-content-container`}>
          <div className="product-card-content">
            <LitStructuredText data={body} basic />
          </div>
          <div className="product-card-list">{list}</div>
          <Link className="button" to={buttonUrl}>
            {buttonText}
          </Link>
        </div>
      </div>
    </div>
  );

  return productCardContent;
};

export default AllProductsCard;
